"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var React = require("react");
var classNames = require("classnames");
var FacetOption = /** @class */ (function (_super) {
    tslib_1.__extends(FacetOption, _super);
    function FacetOption() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    FacetOption.prototype.render = function () {
        return (React.createElement("li", { className: classNames("facet__option facet__option--" + this.props.paramName, {
                'facet__option--disabled': this.props.disabled,
                'facet__option--active': this.props.active,
                'facet__option--child-active': this.props.childActive,
            }) }, this.props.children));
    };
    return FacetOption;
}(React.Component));
exports.default = FacetOption;
//# sourceMappingURL=facet_option.js.map


//////////////////
// WEBPACK FOOTER
// /home/reverb/workspace/core.deploy.production/build/src/node_modules/@reverbdotcom/commons/dist/components/facet_option.js
// module id = ti2W
// module chunks = 0 1 2 3 4 9 10 14 20